/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface LocationService
 */
export interface LocationService {
  /**
   *
   * @type {number}
   * @memberof LocationService
   */
  readonly id: number
  /**
   *
   * @type {string}
   * @memberof LocationService
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof LocationService
   */
  slug?: string | null
}

/**
 * Check if a given object implements the LocationService interface.
 */
export function instanceOfLocationService(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value
  isInstance = isInstance && 'name' in value

  return isInstance
}

export function LocationServiceFromJSON(json: any): LocationService {
  return LocationServiceFromJSONTyped(json, false)
}

export function LocationServiceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LocationService {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    name: json['name'],
    slug: !exists(json, 'slug') ? undefined : json['slug'],
  }
}

export function LocationServiceToJSON(value?: LocationService | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    slug: value.slug,
  }
}
